export default "__VITE_ASSET__C6NOxz5u__"